import { Breadcrumb, Button, Image, message, Spin } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import localization from "../../Localization/Localization.json";
import { fallbackImg } from "../../constants/constants";
import share from "../../assets/share.svg";
import "./SingleProduct.scss";
import {
  PlusCircleOutlined,
  MinusCircleOutlined,
  DeleteFilled,
  LoadingOutlined,
  HeartTwoTone,
  HeartFilled,
} from "@ant-design/icons";
import {
    addProductUserCart,
  favProductUserCart,
  fetchProductInfo,
  removeProductUserCart,
  updateProductUserCart,
} from "../../network/product.network";
import {
  addProductToCart,
  removeProductToCart,
} from "../../redux/cart/cart.action";
import DiscountSection from "../../components/DiscountSection/DiscountSection";
import ResNavBar from "../../components/ResNavBar/ResNavBar";
class SingleProduct extends Component {
  state = {
    isCardAdded: false,
    card_amount: null,
    btnLoading: false,
    updateLoading: false,
    card: null,
    relatedProducts : [],
    isLoading : true
  };

  componentDidMount() {
    this.handelFetchProductInfo();
  }

  handelFetchProductInfo = () => {
    const { match, cartItems } = this.props;
    console.log(match);
    this.setState({isLoading : true})
    fetchProductInfo(
      match?.params?.id,
      (res) => {
        console.log(res);
        console.log(res.data.data);
        const card = res.data.data.product;
        const relatedProducts = res.data.data.relatedProducts;
        this.setState({isLoading : false})
        if (res.data.code === 200) {
          console.log(card);
          const quantityIdxActive =
            card?.inCart && card?.quantities.indexOf(card?.inCart?.quantity);
          if (card.inCart) {
            this.setState({ isCardAdded: true });
            const isProductExistInStorage = cartItems.some(
              (product) => product.id === card.id
            );
            if (!isProductExistInStorage) {
              this.props.dispatch(addProductToCart({ ...card }));
            }
          }
          this.setState({
            card,
            card_amount: {
              quantities: card.quantities,
              inCart: card.inCart,
              quantitiesIndex: quantityIdxActive || 0,
            },
            relatedProducts
          });
        }
      },
      (error) => {
        this.setState({isLoading : false})
        console.log(error);
      }
    );
  }

  handelDltProduct = () => {
    const { card } = this.state;
    console.log(card);
    this.setState({ updateLoading: true });
    let body = new FormData();
    body.append("itemId", card?.inCart?.itemId);
    removeProductUserCart(
      body,
      (res) => { 
        this.setState({ updateLoading: false });
        if (res.data.code === 200) {
          this.setState({ isCardAdded: false, card : {...this.state.card, inCart : null} });
          message.success(res.data.message);
          this.props.dispatch(removeProductToCart(card.id));
        }
      },
      (error) => {
        this.setState({ updateLoading: false });
        console.log(error);
      }
    );
  };

  handelFavProduct = () => {
    const { card } = this.state;
    console.log(card);
    this.setState({ btnLoading: true });
    let body = new FormData();
    body.append("product", +card?.id);
    favProductUserCart(
      body,
      (res) => {
        this.setState({ btnLoading: false });
        if (res.data.code === 200) {
          message.success(res.data.message);
          this.setState({ card: { ...card, isFavorite: res.data.item } });
        }
      },
      (error) => {
        this.setState({ btnLoading: false }); 
        console.log(error);
      }
    );
  };

  handelUpdateProduct = (controlType) => {
    const { card_amount, card } = this.state;
    if (card?.inCart) {
        this.setState({ updateLoading: true });
      let body = new FormData();
      body.append("itemId", card?.inCart?.itemId);
      body.append(
        "quantity",
        card?.quantities[
          controlType === "inc"
            ? card_amount?.quantitiesIndex + 1
            : card_amount?.quantitiesIndex - 1
        ]
      );
      updateProductUserCart(
        body,
        (res) => {
          this.setState({ updateLoading: false });
          if (res.data.code === 200) {
            message.success(
              localization.productupdatedsuccessfully[this.props.currentLang]
            );
            controlType === "inc"
              ? this.setState({
                  card_amount: {
                    ...card_amount,
                    quantitiesIndex: +card_amount.quantitiesIndex + 1,
                  },
                })
              : this.setState({
                  card_amount: {
                    ...card_amount,
                    quantitiesIndex: +card_amount.quantitiesIndex - 1,
                  },
                });
          }
        },
        (error) => {
          this.setState({ updateLoading: false });
          console.log(error);
        }
      );
    } else {
      controlType === "inc"
        ? this.setState({
            card_amount: {
              ...card_amount,
              quantitiesIndex: +card_amount.quantitiesIndex + 1,
            },
          })
        : this.setState({
            card_amount: {
              ...card_amount,
              quantitiesIndex: +card_amount.quantitiesIndex - 1,
            },
          });
    }
  };

  componentWillMount() {
    this.unlisten = this.props.history.listen((location, action) => {
      this.setState({isLoading : true}) 
      setTimeout(() => {
        this.handelFetchProductInfo();  
      }, 500)
    });
  }
  componentWillUnmount() { 
      this.unlisten();
  }
  

  handelAddProductToCart = (product) => {
    const { card_amount, card } = this.state;
    // if(!this.props.currentUser){

    // }
    this.setState({ btnLoading: true });
    let body = new FormData();
    body.append("productId", product.id);
    body.append("quantity", product.quantities[card_amount?.quantitiesIndex]); 
    body.append("offerId", "");
    addProductUserCart(
      body,
      (res) => {
        if (res.data.code === 200) {
          message.success(res.data.message);
          let newCard = { ...card };
          newCard.inCart = {
            itemId: res.data.data.item.id,
            quantity: res.data.data.item.quantity,
          };
          console.log(newCard);
          this.setState({
            isCardAdded: true,
            btnLoading: false,
            card: newCard,
          });
          this.props.dispatch(
            addProductToCart({
              ...product,
              inCart: {
                itemId: res.data.data.item.id,
                quantity: res.data.data.item.quantity,
              },
              product_cart_count: card_amount?.quantitiesIndex,
            })
          );
        }else{
          this.setState({ btnLoading: false });
        }
      },
      (error) => {
        this.setState({ btnLoading: false });
        console.log(error);
      }
    );
  };

  render() {
    const { currentLang } = this.props;
    const { isCardAdded, card_amount, updateLoading, btnLoading, card, relatedProducts, isLoading } =
      this.state;
    return (
      <div className="product-page-wrapper">
        <Header />
        <div className="container">
          <div className="product-content">
            <Breadcrumb separator=">">
              <Breadcrumb.Item>
                <Link to="/">{localization.home[currentLang]}</Link>
              </Breadcrumb.Item>
              {/* <Breadcrumb.Item>
                <Link to="/category/2">women</Link> 
              </Breadcrumb.Item> */}
              <Breadcrumb.Item>{card?.name}</Breadcrumb.Item>
            </Breadcrumb>
            <Spin spinning={isLoading}> 
            <div className="product-info-wrapper">
              <div className="product-info-content">
                <div className="product-img-holder">
                    {card?.percentageValue !== 0 && ( 
                        <p className="product-discount">{card?.percentageValue}%</p>
                    )}
                  <Image
                    src={card?.image || fallbackImg}
                    fallback={fallbackImg}
                    preview={false}
                  />
                </div>
                <div className="product-details-holder">
                  <div className="product-name-holder">
                    <h4>{card?.name}</h4>
                    <div className="share-fav-holder"> 
                    {/* {card?.isFavorite ? <HeartFilled style={{ color : "#ff4d4f" }} onClick={() => this.handelFavProduct(card)} /> : <HeartTwoTone 
                    onClick={() => this.handelFavProduct(card)}
                    twoToneColor={"#00c2ff"} 
                    />
                    } */}
                    <img className="share-btn" src={share} alt="share" /> 
                    </div>
                  </div>
                  <div className="price-holder">
                    <p className="price-after">
                      {card?.discount_price
                        ? card?.price 
                        : card?.price}
                      <span>{localization.AED[currentLang]}</span>
                    </p>
                    {card?.discount_price && (
                      <p className="price-before">
                        {card?.discount_price} {localization.AED[currentLang]}
                      </p>
                    )}
                  </div>
                  <div className="product-desc">
                    <h5>{localization.Description[currentLang]}</h5>
                    <p>{card?.description}</p> 
                  </div>
                  <div className="product-cart-wrapper">
                    <div className="card-control">
                      <Spin
                        indicator={
                          <LoadingOutlined style={{ fontSize: 24 }} spin />
                        }
                        spinning={updateLoading}
                      >
                        <div className="card-count-holder">
                          <Button
                            onClick={() => this.handelUpdateProduct("dec")}
                            disabled={card_amount?.quantitiesIndex === 0}
                          >
                            <MinusCircleOutlined />
                          </Button>
                          <p className="product-count">
                            {card_amount?.quantities[
                                  card_amount?.quantitiesIndex
                                ]} 
                          </p>
                          <Button
                            onClick={() => this.handelUpdateProduct("inc")}
                            disabled={
                              card_amount?.quantitiesIndex ===
                              card?.quantities?.length - 1
                            }
                          >
                            <PlusCircleOutlined />
                          </Button>
                        </div>
                      </Spin>
                    </div>
                    <div className="add-fav-dlt-holder">
                      {card?.inCart ? (
                        <div className="product-fav-dlt">
                          <DeleteFilled
                            className="dlt-btn"
                            onClick={() => this.handelDltProduct(card)}
                          />
                          {card?.isFavorite ? (
                            <HeartFilled
                              style={{ color: "#ff4d4f" }}
                              onClick={() => this.handelFavProduct(card)}
                            />
                          ) : (
                            <HeartTwoTone
                              onClick={() => this.handelFavProduct(card)}
                              twoToneColor={"#00c2ff"}
                            />
                          )}
                        </div>
                      ) : (
                        <Button
                          loading={btnLoading}
                          type="primary"
                          size="large"
                          block
                          className="add-btn"
                          onClick={() => this.handelAddProductToCart(card)}
                        >
                          {localization.Addtocart[currentLang]}
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </div> 
            </div> 
            </Spin> 
            <div className="product-section-wrapper" style={{minHeight : 200}}>
            {/* <Spin spinning={isLoading}>    */} 
            { relatedProducts.length > 0 && <DiscountSection title={localization.RelatedProducts[currentLang]} isSingle discoundList={relatedProducts} />}
            {/* </Spin> */}
            </div>   
          </div>
        </div>
        <Footer />
        <ResNavBar /> 
      </div>
    );
  }
}
const SingleProductWithRouter = withRouter(SingleProduct);

const mapStateToProps = (state) => ({
  cartItems: state.cart.cartItems,
  currentLang: state.user.currentLang,
});

export default connect(mapStateToProps)(SingleProductWithRouter);
